import { useQuery } from '@tanstack/react-query';
import { getTransactionDetail, TransactionDetailResponse } from '@/api/wallet';
import { useAuth } from '@/contexts/AuthContext';

export const useTransactionDetail = (transactionCode: string | null) => {
  const { isAuthenticated } = useAuth();

  return useQuery<TransactionDetailResponse, Error>({
    queryKey: ['transactionDetail', transactionCode],
    queryFn: () => getTransactionDetail(transactionCode!),
    staleTime: 1000 * 60 * 5, // 5分間キャッシュ
    enabled: isAuthenticated && !!transactionCode,
  });
};
